<div class="fc-signup-completed">
    <ng-container *ngIf="!error; else errorMessage">
        <div class="fc-signup-completed-body">
            <div class="fc-signup-completed-body-spinner">
                <img src="assets/img/spinner.svg" class="fa-spin" />
            </div>
            <div class="fc-signup-completed-body-title">{{ 'SIGNUP.ACCOUNT_VERIFICATION.TITLE' | translate }}</div>
            <div class="fc-signup-completed-body-subtitle">
                {{ 'SIGNUP.ACCOUNT_VERIFICATION.SUBTITLE' | translate }}
            </div>
        </div>
    </ng-container>
    <ng-template #errorMessage>
        <div class="fc-signup-completed-error">
            <fc-signup-error
                [errorType]="error"
                [redirectToLogin]="redirectToLogin"
                [actionButtonLabel]="actionButtonLabel | translate"
                (actionButtonClicked)="onActionButtonClick()"
            ></fc-signup-error>
        </div>
    </ng-template>
</div>
